/* Speed Junkies HQ - wraps the word ENTRIES in <span class="sj-ent"> so that
   only the word flashes and the number in front of it stays solid.

   Some of these labels are re-written at runtime by the SpeedjunkiesHQ
   Manager scripts (product-entries-updater.js / giveaway-console.js), which
   set innerHTML to "+N ENTRIES". This file never changes their numbers or
   their logic - it just re-applies the wrapper span afterwards, so the
   Manager tool keeps full control of the value. */
(function () {
  'use strict';
  if (window.__sjEntriesFlash) return;
  window.__sjEntriesFlash = true;

  var SELECTORS = [
    '[data-product-entries-label]',
    '[data-cart-entries-label]',
    '[data-checkout-entries-label]',
    '[data-sj-vip-entries]',
    '[data-sj-entries-label]'
  ].join(',');

  function wrap(el) {
    if (!el || !el.childNodes) return false;
    var changed = false;
    var kids = Array.prototype.slice.call(el.childNodes);
    for (var i = 0; i < kids.length; i++) {
      var node = kids[i];
      if (node.nodeType !== 3) continue;
      var text = node.nodeValue;
      if (!/entries/i.test(text)) continue;
      var parts = text.split(/(entries)/i);
      var frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (!p) continue;
        if (/^entries$/i.test(p)) {
          var span = document.createElement('span');
          span.className = 'sj-ent';
          span.textContent = p;
          frag.appendChild(span);
        } else {
          frag.appendChild(document.createTextNode(p));
        }
      }
      node.parentNode.replaceChild(frag, node);
      changed = true;
    }
    return changed;
  }

  function run() {
    var list = document.querySelectorAll(SELECTORS);
    for (var i = 0; i < list.length; i++) wrap(list[i]);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    var cb = function () { queued = false; run(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(cb);
    else window.setTimeout(cb, 16);
  }

  function boot() {
    run();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (!t) continue;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest(SELECTORS)) { schedule(); return; }
        if (records[i].addedNodes && records[i].addedNodes.length) {
          for (var n = 0; n < records[i].addedNodes.length; n++) {
            var an = records[i].addedNodes[n];
            if (an.nodeType === 1 && an.querySelector && (an.matches(SELECTORS) || an.querySelector(SELECTORS))) {
              schedule();
              return;
            }
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function bootAndPoll() {
    boot();
    var tries = 0;
    var poll = window.setInterval(function () {
      tries++;
      run();
      if (tries > 20) window.clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAndPoll);
  } else {
    bootAndPoll();
  }
})();
